import { useEffect, useRef } from 'react';
import { createConsumer } from '@rails/actioncable';

// Live updates for one coach conversation over AgentConversationChannel.
// Events: new_message, agent_thinking, agent_delta (streamed reply text),
// tool_progress, agent_error.
// The page also polls while a reply is pending, so a dropped socket only
// delays updates; it never loses them.
export default function useCoachChannel(sessionId, handlers) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!sessionId) return undefined;
    let consumer;
    let subscription;
    try {
      consumer = createConsumer();
      subscription = consumer.subscriptions.create(
        { channel: 'AgentConversationChannel', conversation_id: sessionId },
        {
          received: (data) => {
            const h = handlersRef.current || {};
            if (data.type === 'new_message' && h.onMessage) h.onMessage(data.message);
            if (data.type === 'agent_thinking' && h.onThinking) h.onThinking();
            if (data.type === 'agent_delta' && h.onDelta) h.onDelta(data);
            if (data.type === 'tool_progress' && h.onToolProgress) h.onToolProgress(data);
            if (data.type === 'agent_error' && h.onError) h.onError(data.message);
          },
        },
      );
    } catch (e) {
      // ActionCable unavailable (tests, old browsers): polling covers it.
    }
    return () => {
      if (subscription) subscription.unsubscribe();
      if (consumer) consumer.disconnect();
    };
  }, [sessionId]);
}
